import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import type { ValidSendDomain } from '../types';

const generateZodSchema = (validSendDomains: ValidSendDomain[]) => {
  const senderName = z.string();
  const defaultReplyTo = z.string().optional();

  return z.object({
    email: z
      .string()
      .email()
      .refine(
        (email) => {
          if (validSendDomains.length === 0) {
            return true;
          } else {
            const domain = email.split('@')[1];
            return validSendDomains.includes(domain);
          }
        },
        {
          message: `Must end in one of the following domains: ${validSendDomains.join(', ')}`,
        },
      ),
    senderName,
    defaultReplyTo,
  });
};

const schema = z.object({
  email: z.string().email(),
  senderName: z.string(),
  defaultReplyTo: z.string().email().optional(),
});

export type SenderCreateFormContextType = z.infer<typeof schema>;

type SenderCreateFormProviderProps = {
  defaultValues?: SenderCreateFormContextType;
  children: React.ReactNode;
  validSendDomains: ValidSendDomain[];
};

export const SenderCreateFormProvider = ({
  children,
  defaultValues,
  validSendDomains,
}: SenderCreateFormProviderProps) => {
  const methods = useForm<SenderCreateFormContextType>({
    mode: 'onChange',
    resolver: zodResolver(generateZodSchema(validSendDomains)),
    defaultValues,
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
